import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";

const After10th = () => {
  const [courseList, setCourseList] = useState([]);
  const eligibility = "10th or Equivalent"; 

  useEffect(() => {
    const fetchCourseList = async () => {
      try {
        const response = await axios.get(
          `https://isbmuniversity.edu.in/admin-portal/eligibilityCourseList/${eligibility}`
        );
        setCourseList(response.data.data);
      } catch (error) {
        console.error("Error fetching courseList:", error);
      }
    };

    fetchCourseList();
  }, [eligibility]);

  return (
    <React.Fragment>
      {courseList.map((courseTitle) => (
        <li key={courseTitle.id} className="col-lg-5">
          <Link to={`/course-details/${courseTitle.name}`}>
            {courseTitle.title}
          </Link>
        </li>
      ))}
    </React.Fragment>
  );
};

export default After10th;
